import type {KeyboardEvent} from 'react';
import {parseDateRangeInput} from './parseDateRangeInput';

export function confirmDateRangeOnEnter(
  event: KeyboardEvent<HTMLElement>,
  confirm: (range: [Date | null, Date | null] | null, text: string) => void,
) {
  if (event.key !== 'Enter' || !(event.target instanceof HTMLInputElement)) return;
  // Stop the datepicker's own Enter handler before it selects a calendar day.
  event.preventDefault();
  event.stopPropagation();
  if (event.nativeEvent.isComposing) return;
  confirm(parseDateRangeInput(event.target.value), event.target.value);
}
